module.exports = __webpack_public_path__ + "static/media/mappin.a0d3a8ff.svg";